/** HTTP failures retain their status so query retry policy can distinguish load from failure. */
export class HttpError extends Error {
  readonly status: number;
  readonly retryAfterSeconds: number | null;

  constructor(status: number, message: string, retryAfterSeconds: number | null = null) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    this.retryAfterSeconds = retryAfterSeconds;
  }
}

/**
 * Retry one transient network/server failure. Never amplify authentication,
 * authorization, or throttling failures into a second cold-load burst.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof HttpError && [401, 403, 429].includes(error.status)) return false;
  return failureCount < 1;
}
